<template>
  <div>
    <topNav class="section-nav"></topNav>
    <div class="red-box">
      <!-- <h1>职业教育公共服务&nbsp;&nbsp;&nbsp;互联网教育</h1> -->
      <!-- <p>
        VOCATIONAL&nbsp;EDUCATION&nbsp;PUBLIC&nbsp;SERVICE INTERNET EDUCATION
      </p> -->
    </div>
    <full-page :options="options" ref="fullpage">
      <div class="section section1">
        <bannerView></bannerView>
      </div>
      <div class="section section2">
        <newView></newView>
      </div>
      <div class="section section3">
        <coreView></coreView>
      </div>
      <!-- <div class="section section4">
        <solutionView></solutionView>
      </div> -->
      <div class="section section5">
        <productsView ref="prochild"></productsView>
      </div>
      <div class="section section6">
        <develView></develView>
      </div>
      <div class="section section7">
        <serviceView ref="servicechild"></serviceView>
      </div>
      <div class="section section8">
        <partnerView></partnerView>
        <a class="down_bt" @click="movedown"
          ><img src="../assets/images/down.png"
        /></a>
      </div>
      <div class="section fp-auto-height" style="overflow: auto !important">
        <div class="footer-box">
          <div class="sanjiao"></div>
          <footerView></footerView>
        </div>
      </div>
    </full-page>
    <div class="xf-box">
      <div class="xf-list xf-list1">
        <img src="../assets/images/kf.png" alt="" srcset="" />
        <div class="phone">客服电话：400-9999-355</div>
      </div>
      <div class="xf-list xf-list2">
        <img src="../assets/images/rm.png" alt="" srcset="" />
        <div class="weixin">
          <img src="../assets/images/weixin.jpg" alt="" />
        </div>
      </div>
      <div class="xf-list xf-list3" @click="up">
        <img src="../assets/images/up.png" alt="" srcset="" />
      </div>
    </div>
    <Modal
        v-show="modelState"
        v-model="codemodal"
        width="80%"
        class="codemodal"
         footer-hide>
        <div class="code-bs">
          <img style="width:90%" src="../assets/images/code-text.png" alt="">
          <img class="codeerweima" src="../assets/images/codeerweima.png" alt="">
          <div class="iknow-btns" @click="closemodal">进入首页</div>
        </div>
    </Modal>
  </div>
</template>

<script>
import $ from 'jquery'
import topNav from '../components/topNav'
import Nav from '@/components/topNav.vue'
import bannerView from '../components/bannerView'
import newView from '../components/newView'
import coreView from '../components/coreView'
import solutionView from '../components/solutionView'
import productsView from '../components/productsView'
import develView from '../components/develView'
import serviceView from '../components/serviceView'
import partnerView from '../components/partnerView'
import footerView from '../components/footer'
export default {
  components: {
    topNav,
    bannerView,
    newView,
    coreView,
    solutionView,
    productsView,
    develView,
    serviceView,
    partnerView,
    footerView,
    Nav
  },
  data () {
    return {
      codemodal: true,
      modelState: true,
      options: {
        licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
        // 是否显示导航，默认为false
        navigation: true,
        resize: true,
        anchors: [
          'page1',
          'page2',
          'page3',
          'page4',
          'page5',
          'page6',
          'page7',
          'page8'
        ],
        navigationPosition: 'left', // 导航小圆点的位置
        loopBottom: false,
        scrollingSpeed: 1300,
        onLeave: this.onLeavePage,
        afterLoad: this.afterLoadPage
      },
      upshow: false,
      upnum: 0,
      pageIndex: 'page1'
    }
  },
  mounted () {
    let time = localStorage.getItem('modelState')
    // console.log(time, 'time')
    let nowTime = new Date().getTime()
    // console.log(nowTime - time, 'nowTime - time')
    if (nowTime - time > 86400000) {
      this.modelState = true
      localStorage.setItem('modelSatate', nowTime)
    } else if (localStorage.getItem('modelState') == null) {
      localStorage.setItem('modelSatate', nowTime)
      this.modelState = true
    } else {
      this.modelState = false
    }
    let page = localStorage.getItem('page')
    // console.log(page, 'page')
    if (page == null) {
      this.$refs.fullpage.api.moveTo('page1', 0)
    } else {
      this.$refs.fullpage.api.moveTo(page)
    }
  },
  methods: {
    onLeavePage (nextIndex, index) {
      this.pageIndex = index.anchor
      if (index.anchor !== 'page1') {
        $('.section-nav').fadeOut(1000)
        $('.red-box').fadeOut()
        $('.xf-list3').fadeIn()
      } else {
        $('.section-nav').fadeIn(1000)
        $('.red-box').fadeIn()
        $('.xf-list3').fadeOut()
      }
      if (index.index == 1) {
        this.codemodal = false
        // console.log('22')
      }
      if (index.index == 3) {
        this.$refs.prochild.pronum()
      }
     
      if (index.index == 5) {
        this.$refs.servicechild.start()
      }
      // console.log(this.pageIndex, 'index')
    },
    afterLoadPage (anchorLink, index) {

    },
    movedown () {
      this.$refs.fullpage.api.moveSectionDown()
    },
    up () {
      this.$refs.fullpage.api.moveTo('page1', 0)
    },
    closemodal () {
      let time = new Date().getTime()
      localStorage.setItem('modelState', time)
      this.modelState = false
    }
  },
  destroyed () {
    let page = this.pageIndex
    localStorage.setItem('page', page)
  }
}
</script>

<style>
.fp-auto-height.fp-section,
.fp-auto-height .fp-slide,
.fp-auto-height .fp-tableCell {
  height: auto !important;
}
.swiper-container {
  height: 100%;
  width: 100%;
}
.codemodal .ivu-modal-body{
padding: 0;
height: 480px !important;
z-index: 999999;
}
.ivu-modal-content{
  background-color: transparent !important;
  box-shadow: none;
}
.code-bs{
  text-align: center;
}
.codeerweima{
  margin-top: 10vh;
}
.iknow-btns{
  text-align: center;
  border: 1px solid #fff;
  height: 50px;
  line-height: 50px;
  width: 170px;
  color: #fff;
  font-size: 18px;
  border-radius: 25px;
  margin: auto;
  margin-top: 30px;
  cursor: pointer;
  letter-spacing: 2px;
}
.vertical-center-modal{
        display: flex;
        align-items: center;
        justify-content: center;

    }
    .ivu-modal{
            top: 15%;
        }
.ivu-modal-mask{
  background-color: rgba(0, 0, 0, 0.7);
}
.ivu-modal-close{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue